import {
  call, put, takeEvery, select, cancel, debounce, takeLatest,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import { showErrorNotification } from 'store/shared/actions';
import {
  getWishlistItemsFilters,
} from 'store/wishlist-items/selectors';
import { FILTER_KEYS } from './fixtures';
import * as constants from './constants';
import * as actions from './actions';
import { resetUpdatedItems } from '../items/actions';

export function* getWishlistItems() {
  try {
    const {
      [FILTER_KEYS.HAS_MORE]: hasMore,
      [FILTER_KEYS.PAGE]: page,
      ...query
    } = yield select(getWishlistItemsFilters);
    const currentPage = hasMore ? page + 1 : 1;
    const params = {
      query: {
        ...query,
        [FILTER_KEYS.PAGE]: currentPage,
        [FILTER_KEYS.TAGS]: query[FILTER_KEYS.TAGS].map(({ id }) => id),
        [FILTER_KEYS.ITEMS]: query[FILTER_KEYS.ITEMS].map(({ id }) => id),
      },
    };
    const { data } = yield call(request, API.WISHLIST, 'GET', params);

    yield put(actions.getWishlistItemsSuccess({
      data,
      filters: {
        ...query,
        [FILTER_KEYS.PAGE]: currentPage,
        [FILTER_KEYS.HAS_MORE]: data.length > 0 && query[FILTER_KEYS.PER_PAGE] === data.length,
      },
    }));

    if(currentPage === 1) {
      resetUpdatedItems();
    }
  } catch (e) {
    yield put(actions.getWishlistItemsError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}
// eslint-disable-next-line import/prefer-default-export
export function* getWishlistItemsWatcher() {
  yield takeEvery(constants.GET_WISHLIST_ITEMS, getWishlistItems);
}

// eslint-disable-next-line import/prefer-default-export
export function* getWishlistItemsDebaunced(action) {
  const filters = yield select(getWishlistItemsFilters);

  const isLatestFiltersVersion = JSON.stringify(filters) === JSON.stringify(action.payload.filtersSnapshot);

  if(isLatestFiltersVersion) {
    yield put(actions.setWishlistItemsFilters(action.payload.values));
    yield put(actions.getWishlistItems());
  }

  yield cancel();
}

export function* getWishlistItemsDebauncedWatcher() {
  yield debounce(2000, constants.GET_WISHLIST_ITEMS_DELAYED, getWishlistItemsDebaunced);
}
